export const INDICADOR_TIPOS = [
  { id: 'AGENCIA', label: 'Agência', kind: 'empresa' },
  { id: 'PLATAFORMA', label: 'Plataforma', kind: 'empresa' },
  { id: 'INDICADOR', label: 'Indicador', kind: 'pessoa' },
  { id: 'OUTRO', label: 'Outro', kind: 'pessoa' },
] as const

export type IndicadorTipo = (typeof INDICADOR_TIPOS)[number]['id']

export function indicadorTipoLabel(tipo?: string | null) {
  const value = (tipo ?? '').trim().toUpperCase()
  if (value === 'RP' || value === 'INDICADOR') return 'Indicador'
  return INDICADOR_TIPOS.find((item) => item.id === value)?.label ?? '—'
}

export function indicadorTipoKind(tipo: IndicadorTipo) {
  return INDICADOR_TIPOS.find((item) => item.id === tipo)?.kind ?? 'pessoa'
}
